import { HTMLAttributes } from 'react'

import cn from '@/utils/tailwind/cn'

export const FormsAnalyticsCardSubtitle = ({
  className,
  ...props
}: HTMLAttributes<HTMLParagraphElement>) => (
  <p className={cn('mt-1 text-xs text-gray-500/70', className)} {...props} />
)
